var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChatBlue = function SvgIconChatBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.917 16.917a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
    fill: "#94C6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.825 13.97 5.092 2.947H3.989c-.78 0-1.17-.942-.618-1.494l1.454-1.454Z",
    fill: "#94C6F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.828 10.74a.824.824 0 1 0 0-1.647.824.824 0 0 0 0 1.648ZM9.917 10.74a.824.824 0 1 0 0-1.647.824.824 0 0 0 0 1.648ZM13.006 10.74a.824.824 0 1 0 0-1.647.824.824 0 0 0 0 1.648Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 25.083a8.458 8.458 0 1 0 0-16.916 8.458 8.458 0 0 0 0 16.916Z",
    fill: "#3987F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m22.78 21.522-6.155 3.562h6.9c1.04 0 1.56-1.258.825-1.993l-1.57-1.569Z",
    fill: "#3987F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.357 17.62a.995.995 0 1 0 0-1.99.995.995 0 0 0 0 1.99ZM16.625 17.62a.995.995 0 1 0 0-1.99.995.995 0 0 0 0 1.99ZM12.893 17.62a.995.995 0 1 0 0-1.99.995.995 0 0 0 0 1.99Z",
    fill: "#fff"
  })));
};
export default SvgIconChatBlue;